// §4.4 partial — admin/broker-currency.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminBrokerCurrencyPage = lazyWithRetry(
  () => import("./pages/AdminBrokerCurrencyPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/moeda", Component: AdminBrokerCurrencyPage }],
  },
];

export default routes;
